import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Toast, ToastContainer } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import ConfirmDeleteModal from '../../components/DeleteModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL } from '../../constants';
import Layout from '../../components/Layout';

import {
  Container,
  Form,
  Table,
  Button,
  Pagination,
  Card,
  Col,
  Modal,
  Alert
} from 'react-bootstrap';

import moment from 'moment';

const AdminTable = () => {
  const [assignError, setAssignError] = useState(null);
  const [originalAdmin, setOriginalAdmin] = useState(null);
  const [rooms, setRooms] = useState([]);
  const [emailVerificationNotice, setEmailVerificationNotice] = useState(false);

  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedAdminId, setSelectedAdminId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editForm, setEditForm] = useState({});

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredAdmins.length / itemsPerPage);

  // Fetch admins
  const fetchAdmins = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/users/admins`);
      const onlyAdmins = res.data;
      setAdmins(onlyAdmins);
      setFilteredAdmins(onlyAdmins);
    } catch (error) {
      console.error('Error fetching admins:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  // Search filter
  useEffect(() => {
    const lowerSearch = search.toLowerCase();
    const filtered = admins.filter((admin) => {
      return (
        (admin.identifiant && admin.identifiant.toLowerCase().includes(lowerSearch)) ||
        (admin.firstName && admin.firstName.toLowerCase().includes(lowerSearch)) ||
        (admin.lastName && admin.lastName.toLowerCase().includes(lowerSearch))
      );
    });
    setFilteredAdmins(filtered);
  }, [search, admins]);

  // Edit admin
  const handleEdit = (admin) => {
    setEditForm({
      ...admin,
    });
    setShowEditModal(true);
  };
  

  // Delete admin
  const handleDeleteClick = (admin) => {
    setSelectedAdmin(admin);
    setSelectedAdminId(admin._id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
        setLoading(true);
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/users/${selectedAdminId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAdmins(prev => prev.filter(a => a._id !== selectedAdminId));
      setShowDeleteModal(false);
      setToastMessage('Admin deleted successfully!');
      setShowToast(true);
    } catch (error) {
      console.error('Error deleting admin:', error);
    } finally {
        setLoading(false);
    }
  };

  // Form change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Save changes
  const handleSaveChanges = async () => {
    setIsLoading(true);
    setAssignError(null);
    setAlertMessage(null);
  
    const token = localStorage.getItem("token");
  
    try {
      const formData = new FormData();
      formData.append("firstName", editForm.firstName);
      formData.append("lastName", editForm.lastName);
      if (editForm.email?.trim()) formData.append("email", editForm.email);
      formData.append("phone", editForm.phone);
      formData.append("gender", editForm.gender);
      formData.append("dateOfBirth", moment(editForm.dateOfBirth).toISOString());
  
  
      if (editForm.profilePhoto instanceof File) {
        formData.append("profilePhoto", editForm.profilePhoto);
      }
  
      const response = await axios.put(`${BASE_URL}/users/${editForm._id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.status === 200) {
        setAdmins((prev) =>
          prev.map((a) => (a._id === editForm._id ? { ...a, ...response.data.user } : a))
        );
        setAlertMessage("Updated successfully!");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
          setShowEditModal(false);
           fetchAdmins();
        }, 3000);
      } else {
        setAssignError("Update failed. Please try again.");
      }
    } catch (error) {
      console.error("Error updating admin:", error);
      setAssignError("Failed to update user details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <Layout>
      <>
      {loading ? (
       <div className="text-center"></div>
  ) : filteredAdmins && filteredAdmins.length > 0 ? (
            <Card border="light" className="shadow-sm mt-3">
              <Card.Body className="pt-0">
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th className="text-center">#</th>
                   
                      <th className="text-center">Name</th>
                      <th className="text-center">Email</th>
                      <th className="text-center">Phone</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...filteredAdmins]
                      .sort((a, b) => new Date(b.entryDate) - new Date(a.entryDate))
                      .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                      .map((admin, index) => (
                        <tr key={admin._id}>
                          <td className="text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                   
                          <td className="text-center">{(admin.firstName || '-') + ' ' + (admin.lastName || '-')}</td>
                          <td className="text-center">{admin.email || '-'}</td>
                          <td className="text-center">{admin.phone || '-'}</td>
                          <td className="text-center">
                          <Button
  variant="primary"
  size="sm"
  className="me-2"
  onClick={() => handleEdit(admin)}
>
  <FontAwesomeIcon icon={faEdit} size="sm" /> 
</Button>

<Button
  variant="danger"
  size="sm"
  onClick={() => handleDeleteClick(admin)}
>
  <FontAwesomeIcon icon={faTrashAlt} size="sm" />
</Button>

                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>

                <Pagination className="mt-3">
                  <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>Previous</Pagination.Prev>
                  {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)} className="mx-1">
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>Next</Pagination.Next>
                </Pagination>
              </Card.Body>
            </Card>
  ) : (
    <div className="card mt-3">
      <div className="card-body">
        <p className="card-text">Currently, there are no admins found.</p>
      </div>
    </div>
  )}

        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formFirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" name="firstName" value={editForm.firstName || ''} onChange={handleFormChange} placeholder="Enter first name" />
              </Form.Group>
              <Form.Group controlId="formLastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" name="lastName" value={editForm.lastName || ''} onChange={handleFormChange} placeholder="Enter last name" />
              </Form.Group>
              <Form.Group controlId="formEmail">
                {emailVerificationNotice && (
                  <Col md={12}>
                    <ToastContainer position="top-end" className="p-3">
                      <Toast show={emailVerificationNotice} onClose={() => setEmailVerificationNotice(false)} bg="warning" delay={5000} autohide>
                        <Toast.Header>
                          <strong className="me-auto">Verification Email Sent</strong>
                        </Toast.Header>
                        <Toast.Body>
                          A verification email has been sent. Please check your inbox to activate your email.
                        </Toast.Body>
                      </Toast>
                    </ToastContainer>
                  </Col>
                )}
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={editForm.email || ''} onChange={handleFormChange} placeholder="Enter email address" />
              </Form.Group>
              <Form.Group controlId="formPhone">
                <Form.Label>Phone</Form.Label>
                <Form.Control type="text" name="phone" value={editForm.phone || ''} onChange={handleFormChange} placeholder="Enter phone number" />
              </Form.Group>

            </Form>
            <div className='mt-3'>
              {assignError && <Alert variant="danger">{assignError}</Alert>}
              {showAlert && <Alert variant="success">{alertMessage}</Alert>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
            <Button variant="primary" onClick={handleSaveChanges}>Save Changes</Button>
          </Modal.Footer>
        </Modal>

        <ConfirmDeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={confirmDelete}
          itemName={selectedAdmin?.firstName && selectedAdmin?.lastName ? `${selectedAdmin.firstName} ${selectedAdmin.lastName}` : selectedAdmin?.identifiant || 'Unknown'}
          loading={loading} 
        />

        <ToastContainer position="top-end" className="p-3">
          <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg="success">
            <Toast.Body className="text-white">{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    </Layout>
  );
};

export default AdminTable;
